import { splitLeadingHeading } from "@/components/storyboard/text/utils/splitLeadingHeading";
import { titledBodyMarkdown } from "@/components/storyboard/text/utils/titledBodyMarkdown";
import type { TextTitledBodyData } from "@/types/storyboard";

export interface TitledBody {
  title: string | null;
  body: string;
}

/**
 * Reads a payload in either shape: `{ title, body }`, or the bare markdown
 * string older courses carry, where the title is the heading on the first
 * line — which is where `splitLeadingHeading` finds it.
 */
export const resolveTitledBody = (
  data: TextTitledBodyData | string
): TitledBody => {
  if (typeof data === "string") {
    return splitLeadingHeading(data);
  }

  return {
    title: data.title?.trim() || null,
    body: titledBodyMarkdown(data),
  };
};
